// Lib
import * as React from 'react';

// Components
import { ToolButton } from '@ibinder/common-frontend';
import { chevronDown, chevronUp } from '@ibinder/common-icons';

// Styles
import { ColorSquare, BoldSpan } from './cellRendering.styles';

// Utils
import {
  extractRenderValueBasedOnType,
  MetadataType
} from '@ibinder/common-utils';
import { BinderParticipantLevelEnum } from '@ibinder/common-utils';

const yesNoRenderer =
  () =>
  ({ cell }) =>
    cell.value !== null ? (cell.value === '1' ? 'Yes' : 'No') : '';

const extractByLevel =
  (level: BinderParticipantLevelEnum) =>
  ({ row }) => {
    const byLevel = row?.original?.document?.participants?.filter(
      (participant: any) => participant.level === level
    ).length;
    return byLevel ? byLevel : '';
  };
export const GROUP_BY_ACCESSOR = 'BINDER_TYPE';

export const templateHeaders = () => [
  {
    id: '0',
    name: 'Template name',
    propName: 'name',
    Aggregated: (p) => (
      <ToolButton type="button" onClick={() => ({})}>
        {p.row.isExpanded ? chevronUp : chevronDown}
        <BoldSpan>{`common:binderTypes.${p.row.groupByVal}`}</BoldSpan>
      </ToolButton>
    ),
    Cell: ({ cell }) => cell.value
  },
  {
    id: GROUP_BY_ACCESSOR,
    name: 'Binder type',
    propName: 'binderType',
    PlaceHolder: ({ cell }) => `common:binderTypes.${cell.value}`
  },
  { id: '2', name: 'Description', propName: 'description' },
  {
    id: '3',
    name: 'Color',
    propName: 'defaultColor',
    Cell: ({ cell }) =>
      cell.value !== null ? <ColorSquare color={cell.value} /> : ''
  },
  {
    id: '4',
    name: 'Color locked',
    propName: 'colorLocked',
    Cell: yesNoRenderer(),
    type: MetadataType.Boolean
  },
  {
    id: '7',
    name: 'Adminstrators',
    propName: 'participants',
    Cell: extractByLevel(BinderParticipantLevelEnum.Admin),
    type: MetadataType.ArrayCount
  },
  {
    id: '8',
    name: 'Participants',
    propName: 'participants',
    Cell: extractByLevel(BinderParticipantLevelEnum.Participant),
    type: MetadataType.ArrayCount
  }
];

export const templatesSettings = () => ({
  metadataElements: templateHeaders()
});

export const templateList = (templates) =>
  templates
    ? templates
        .map((template) => ({
          ...template
        }))
        .filter((template) => template.tenantSpecific)
    : templates;

export const attachTransformedMetadata = (data, settings, headers) =>
  [...data].map((e: any) => ({
    ...e,
    metadata: headers.map((h) => ({
      metadataElementId: h.id,
      value: e[h.propName] ? e[h.propName] : '',
      sortValue: extractRenderValueBasedOnType(settings.metadataElements, {
        metadataElementId: h.id,
        value: e[h.propName] ? e[h.propName] : ''
      })
    }))
  }));
